import styled, { css } from 'styled-components';

import Tooltip from '../../../Tooltip';

interface ContainerProps {
	isFocused: boolean;
	isField: boolean;
	isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
	display: flex;
	align-items: center;
  background: #fff;
	border: 1px solid #b0bec5;
  border-radius: 6px;
  width: 100%;
	// padding-right: 10px;
  color: #333; // #455a64;
  cursor: pointer;

  & + div {
    margin-top: 8px;
  }

  ${props =>
		props.isErrored &&
		css`
      border-color: #c53030;
    `}

  ${props =>
		props.isFocused &&
		css`
      color: var(--azul-razio);
      border-color: var(--azul-razio);
    `}

  ${props =>
		props.isField &&
		css`
      color: var(--azul-razio);
    `}

  > svg {
    margin-right: 16px;
  }

	[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff !important;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;